module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_mgbt-16px _fs-3 _tal-ct _tal-l-sm"
  }, [_c('strong', [_vm._v("Biomatic เบื้องต้น")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdrd-2px _pdh-16px _pdv-16px"
  }, [_c('p', {
    staticClass: "_pdl-8px _fs-4 _mgbt-8px _cl-accent"
  }, [_c('strong', [_vm._v("Atomic Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px "
  }, [_vm._v("\n        • เป็นหัวใจหลักของ Biomatic ใช้กำหนดค่า Style หรือใช้ร่วมกับ Class อื่นๆ เพื่อแสดงผลลัพท์ที่ต้องการ\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_*")]), _vm._v(" และชื่อ Class เป็นคู่ของ Name-Value เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_mgl-8px")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • Name, Value จะเป็นตัวย่อตามพยางค์ของการออกเสียง"), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("margin-left: 8px")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_mgr-8px")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("padding-bottom: auto")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_pdbt-at")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("width: 100%")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_w-100pct")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("text-align: center")]), _vm._v(" เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("_tal-ct")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-16px _mgbt-8px"
  }, [_vm._v("\n        • สามารถใส่ Breakpoint "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-sm")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-md")]), _vm._v(" และ "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-lg")]), _vm._v("\n        ที่ Class เพื่อกำหนดการแสดงผลแบบ Responsive ได้\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-8px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!--\nText-align Left,\nText-align Center on SMALL size or upper,\nText-align Right on MEDIUM size or upper,\nHeight of 32pixel,\nPositive background color,\nWarning background color on SMALL size or upper,\n-->\n<div class=\"_tal-l _tal-ct-sm _tal-r-md _h-32px _bgcl-positive _bgcl-warning-md\">\n  item\n</div>\n")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 _mgbt-64px"
  }, [_c('div', {
    staticClass: "_tal-l _tal-ct-sm _tal-r-md _h-32px _bgcl-positive _bgcl-warning-sm"
  }, [_vm._v("\n            item\n          ")])])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Components Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • สำหรับใช้แสดงผล Element ต่างๆ เช่น Button, Breadcrumb หรือ Accordion เป็นต้น\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-link")])]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-24px-sm _mgbt-32px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button _mgr-8px-sm _mgbt-8px"
  }, [_vm._v("bio-button")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link _als-ct"
  }, [_vm._v("bio-link")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใส่ Option ด้วย "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-*")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button -loading")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("bio-button -positive -outline")]), _vm._v("\n        ซึ่งรูปแบบการลักษณะนี้ จะหมือนกับ Switched ใน UNIX commandline เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("ls -a")]), _vm._v(" เป็นต้น\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-24px-sm _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _alit-fst-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button -loading _mgr-8px-sm _mgbt-8px"
  }, [_vm._v("bio-button -loading")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button -positive -outline"
  }, [_vm._v("bio-button -positive -outline")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Layout Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้เป็น Container เพื่อการจัดวาง และการแสดงผลของ Contents หรือ Component ด้านใน\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • Responsive grid ใช้ Grid 12\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • Breakpoints มีสามขนาดใ ช้ Suffix เป็น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-sm")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-md")]), _vm._v(" และ "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-lg")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-container")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-4")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-8-2")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("lo-7-5-sm")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใส่ Option ด้วย "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("-*")]), _vm._v(" เช่น เพื่อตั้งค่าการแสดงผล เช่น ขนาด Gutter ได้\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-32px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-4 -gap-8px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-4 -gap-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])]), _vm._v(" "), _c('div', {
    staticClass: "_pdl-24px-sm _mgbt-64px"
  }, [_c('pre', [_vm._v("          "), _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"lo-12 lo-8-4-sm -gapv-12px -gaph-2px\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-8-4-sm -gapv-12px -gaph-2px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _h-32px _dp-f _jtfct-ct _alit-ct"
  }, [_vm._v("item")])])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px _cl-accent _fs-4"
  }, [_c('strong', [_vm._v("Utility Class")])]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้เพิ่มการแสดงผลพฤติกรรม หรืออำนวยความสะดวกต่างๆ เช่น Animation\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "_pdl-8px _mgbt-8px"
  }, [_vm._v("\n        • ใช้ Prefix "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-")]), _vm._v(" เช่น "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-animation-*")]), _vm._v(", "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("u-hover-*")])]), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _pdl-16px _mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-cl _fdrt-r-sm _alit-fst-sm _mgbt-8px"
  }, [_c('div', {
    staticClass: "bio-button _mgr-8px _mgbt-24px _mgbt-0px-sm u-animation-pulse"
  }, [_vm._v("bio-button u-animation-pulse")]), _vm._v(" "), _c('div', {
    staticClass: "bio-button u-rise"
  }, [_vm._v("bio-button u-rise")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310876c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/HomeGettingStartBasic.vue
// module id = 120
// module chunks = 0